import { render, staticRenderFns } from "./RequestMoney.vue?vue&type=template&id=16836b18&scoped=true&"
import script from "./RequestMoney.vue?vue&type=script&lang=js&"
export * from "./RequestMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16836b18",
  null
  
)

export default component.exports